import React, { useRef, useState } from "react";
import IdleTimer from "react-idle-timer";
import SessionTimeoutDialog from "./SessionTimeoutDialog";

let countdownInterval;
let timeout;

const SessionTimeout = ({ isAuthenticated }) => {
    const [timeoutModalOpen, setTimeoutModalOpen] = useState(false);
    const [timeoutCountdown, setTimeoutCountdown] = useState(0);
    const idleTimer = useRef(null);

    const clearSessionTimeout = () => clearTimeout(timeout);
    const clearSessionInterval = () => clearInterval(countdownInterval);

    const logoutUser = () => {
        // Clear auth (MSAL/localStorage/cookies/session etc.)
        localStorage.clear();  // <-- or call MSAL logout if used
        sessionStorage.clear();
		window.onbeforeunload = null;
        window.location.href = "/login";
    };

	const handleLogout = async (isTimedOut = false) => {
		try {
			clearSessionInterval();
			clearSessionTimeout();
	
			// Disable onbeforeunload to suppress "Leave site?" dialog
			window.onbeforeunload = null;
	
			if (isTimedOut) {
				logoutUser();
			} else {
				setTimeoutCountdown(0);
				setTimeoutModalOpen(true);
			}
		} catch (err) {
			console.error(err);
		}
	};


    const handleContinue = () => {
        setTimeoutModalOpen(false);
        clearSessionInterval();
        clearSessionTimeout();
        window.onbeforeunload = null;
        window.location.reload(true);
    };

    const onActive = () => {
        if (!timeoutModalOpen) {
            clearSessionInterval();
            clearSessionTimeout();
        }
    };

	const onIdle = () => {
		const delay = 1000 * 1;
		if (isAuthenticated && !timeoutModalOpen) {
			timeout = setTimeout(() => {
				let countDown = 15;
				setTimeoutModalOpen(true);
				setTimeoutCountdown(countDown);
				countdownInterval = setInterval(() => {
					if (countDown > 0) {
						setTimeoutCountdown(--countDown);
					} else {
						handleLogout(true);
						clearSessionInterval();
						clearSessionTimeout();
					}
				}, 1000);
			}, delay);
		}
	};

    return (
        <>
            <IdleTimer
                ref={idleTimer}
                onActive={onActive}
                onIdle={onIdle}
                debounce={250}
                timeout={1200000} //20 minutes
            />

            <SessionTimeoutDialog
                countdown={timeoutCountdown}
                onContinue={handleContinue}
                onLogout={() => handleLogout(false)}
                open={timeoutModalOpen}
            />
        </>
    );
};

export default SessionTimeout;
